export function Avatar({
  avatarUrl,
  nickname,
  size = 32,
}: {
  avatarUrl: string | null | undefined;
  nickname: string;
  size?: number;
}) {
  const dim = { width: size, height: size };
  if (avatarUrl) {
    return (
      <img
        src={avatarUrl}
        alt={nickname}
        style={dim}
        className="shrink-0 rounded-full object-cover ring-1 ring-cyan-400/30"
      />
    );
  }
  const initial = (nickname.trim()[0] ?? "?").toUpperCase();
  return (
    <span
      style={dim}
      aria-hidden="true"
      className="flex shrink-0 items-center justify-center rounded-full bg-cyan-400/15 text-xs font-semibold text-cyan-200 ring-1 ring-cyan-400/30"
    >
      {initial}
    </span>
  );
}
